import * as FlightScannerActions from "../actions/flights/FlightScanner.Actions";
import { IFlightError } from "@vmosolutions/oc-interfaces";

export interface IFlightScannerState {
  hasData: boolean;
  isFlightScannerFinished: boolean;
  flightErrors: IFlightError[];
  flightErrorsMap: IFlightErrorMap;
}

export interface IFlightErrorMap {
  [aircraftId: string]: {
    errors: IFlightError[];
    errorIds: Set<string>;
    lastModified: number;
  };
}

const initialState: IFlightScannerState = {
  hasData: false,
  isFlightScannerFinished: true,
  flightErrors: [],
  flightErrorsMap: {},
};

export const FlightScannerReducer = (
  state: IFlightScannerState = initialState,
  action: FlightScannerActions.Action
): IFlightScannerState => {
  switch (action.type) {
    case FlightScannerActions.Type.SET_FLIGHT_SCANNER_RUNNING:
      return {
        ...state,
        isFlightScannerFinished: action.isFlightScannerFinished,
      };
    case FlightScannerActions.Type.GOT_FLIGHT_SCANNER_RESULTS: {
      const newFlightErrorsMap = {};
      action.flightErrors.forEach((flightError: IFlightError) => {
        addToFlightErrorsMap(flightError, newFlightErrorsMap);
      });
      return { ...state, hasData: true, flightErrors: action.flightErrors, flightErrorsMap: newFlightErrorsMap };
    }
    case FlightScannerActions.Type.GOT_FLIGHT_ERRORS: {
      const flightErrorsMap = { ...state.flightErrorsMap };
      const { newErrors, fixedErrors } = action;
      fixedErrors.forEach((fixedError: IFlightError) => {
        const { aircraftId } = fixedError;
        if (aircraftId) {
          const index = flightErrorsMap[aircraftId]?.errors.findIndex((value: IFlightError) => {
            return value.validationPath === fixedError.validationPath;
          });
          if (index >= 0) {
            flightErrorsMap[aircraftId].errors.splice(index, 1);
            flightErrorsMap[aircraftId].lastModified = Date.now();
          }
        }
      });
      newErrors.forEach((newError: IFlightError) => {
        addToFlightErrorsMap(newError, flightErrorsMap);
      });
      return { ...state, flightErrorsMap, hasData: true };
    }
    default:
      return state;
  }
};

const addToFlightErrorsMap = (error: IFlightError, flightErrorsMap: IFlightErrorMap): void => {
  const { aircraftId } = error;
  if (!aircraftId) {
    return;
  }
  if (!flightErrorsMap[aircraftId]) {
    flightErrorsMap[aircraftId] = {
      errors: [],
      lastModified: 0,
      errorIds: new Set(),
    };
  }
  if (!flightErrorsMap[aircraftId].errorIds.has(error.validationPath)) {
    flightErrorsMap[aircraftId].errorIds.add(error.validationPath);
    flightErrorsMap[aircraftId].errors.push(error);
    flightErrorsMap[aircraftId].lastModified = Date.now();
  } else {
    // console.warn("Duplicate Validation Path Error - you might need to refresh your flight errors collection");
  }
};
